<script setup>
import useFavorites from '@/Shared/useFavorites.js'
import ListButton from '@/Shared/List/ListButton'
const props = defineProps({
  list: Array,
  title: String,
  category: String,
})

const { updateFavoriteList } = useFavorites({ category: props.category })
</script>

<template>
  <div v-if="props.list.length" class="relative w-full flex flex-col max-h-[300px]">
    <div v-if="props.title" class="link-title text-[15px] font-bold pb-4 mb-5 border-b border-b-black border-dotted">{{ props.title }}</div>
    <ul class="link-list max-h-full min-h-[30px] overflow-y-auto mr-[-25px] pr-[25px]" @click="updateFavoriteList">
      <transition-group name="list-anim">
        <li v-for="item in props.list" :key="item[props.category + 'ID']" class="relative first:mt-[-5px] last:mb-0">
          <ListButton v-if="props.category === 'brand'" type="link" :category="category" :item="item" />
          <ListButton v-if="props.category === 'shop'" type="link" :category="category" :item="item" />
        </li>
      </transition-group>
    </ul>
  </div>
</template>
